module.exports = __webpack_public_path__ + "img/bg_avatar_female_12.9ad3fbbf.png";